/*eslint-disable */

import { bus } from '@/main';
import toast from '@/services/toast';
import twoFactorDataPopup from '@/components/private/dataset/two-factor-for-data-popup/';

export default {
  name: 'data-list-based-on-org',
  components: {
    'two-factor-data' : twoFactorDataPopup
  },
  props: ['orgKeyword', 'catStatePROP'],
  data () {
    return {
      selectedTeamMemberData:null,
      selectedTeamMemberDataResults:[],
      submitted:false,
      apiResLoader:false,
      twoFactorVerifedPopup:false,
      twoFactorDataId:'',
      title:'',
      orgState:'',
      userAuthorizedPopupState:false
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('twoFactorVerifedPopupBus', (data) => {
      this.twoFactorVerifedPopup = data;
    });
    this.getSelectedTeamMemberDataMethod();
  },
  methods: {
    twoFactorVerifedPopupOpenMethod(ID){
      this.$store.dispatch('sendTwoFactorOtp', {id:ID}).then((res) => {
        toast.success(res.data.user_msg);
        this.twoFactorVerifedPopup = true
        this.twoFactorDataId = 
        document.body.classList.add('body_right_scroll_remove');
      })
    },
    getSelectedTeamMemberDataMethod(){     
      this.orgState = this.catStatePROP
      this.$store.dispatch('getAllAlgoDataBasedOrgAction', {org:this.orgKeyword, state:this.orgState}).then((res) => {
        this.selectedTeamMemberData = res.data.data
        this.selectedTeamMemberDataResults = this.selectedTeamMemberData.results
      })
    },
    searchAlgoDataMethod(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.title.length > 2){
            this.submitted = true
            let data = {
              search : this.title,
              state:this.orgState
            }        
            this.$store.dispatch('searchAlgoDataAction', data).then((res) => {
              this.selectedTeamMemberData = res.data.data
              this.selectedTeamMemberDataResults = this.selectedTeamMemberData.results
              this.submitted = false
            }).catch((err) => {
              this.submitted = false
            })
          }else if(this.title.length == 0){
            this.getSelectedTeamMemberDataMethod();
          }
        }
      })
    },
    userAuthriozedNotDownLoadDataMethod(){
      document.body.classList.add('body_right_scroll_remove');
      this.userAuthorizedPopupState = true
    },
    userAuthorizedPopupMethod(){
      document.body.classList.remove('body_right_scroll_remove')
      this.userAuthorizedPopupState = false
    },
    downloadFileMethod(file,fileName){
      var link = document.createElement('a');
      link.href = file
      link.download =  fileName;
      document.body.appendChild(link);
      link.click();
    },
    selectedAlgoDataDetailsByIdMethod(dataId){
      this.$store.dispatch('getAllPubAlgoDataListByIdAction',{id:dataId}).then((res)=>{
        this.downloadFileMethod(res.data.data.data_file,res.data.data.data_file_name)
      }).catch((err)=>{

      })
    },
  }
}